import React, {useEffect, useState} from "react"
import {} from "@mui/material";

import "ol";
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import TileLayer from 'ol/layer/Tile';
import { fromLonLat, toLonLat } from "ol/proj.js";
import Point from "ol/geom/Point";
import { Feature } from "ol";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import {Control, defaults as defaultControls} from 'ol/control';
import {Style, Fill, Stroke, Circle, Text} from 'ol/style.js';
import LayerGroup from "ol/layer/Group";


// class CustomControl extends Control {
//   /**
//    * @param {Object} [opt_options] Control options.
//    */
//   constructor(opt_options) {
//     const options = opt_options || {};

//     const button = document.createElement('button');
//     button.innerHTML = 'N';

//     const element = document.createElement('div');
//     element.className = 'rotate-north ol-unselectable ol-control';
//     element.appendChild(button);

//     super({
//       element: element,
//       target: options.target,
//     });

//     // button.addEventListener('click', this.handleRotateNorth.bind(this), false);
//   }

//   handleRotateNorth() {
//     this.getMap().getView().setRotation(0);
//   }
// }



export const MapBase = (props) => {
  // const {CustomLayers, mapCenter} = props;
  const height = props.height ? props.height : "100%"

  const [map, setMapState] = useState(null);
  const tilesource = new TileLayer({source: new OSM(), name: "base"});
  useEffect(() => {
    loadBaseMap();
  }, []);

  useEffect(() => {
    loadCustomLayers();
  }, [props.CustomLayers, map])


  const loadCustomLayers = () => {
    if (map != null){
      //remove old custom layers:
      let toRemove = [];
      map.getLayers().getArray().slice().forEach(layer => {
        if (layer && (layer.get("name") == null || layer.get("name") !== "base")){
          // toRemove.push(layer);
          map.removeLayer(layer);
        }
      });

      if (props.CustomLayers != null){
        props.CustomLayers.forEach(layer => {
          map.addLayer(layer);
        })
      }
    }
  }

  const loadBaseMap = () => {
    let center = props.mapCenter ? fromLonLat(props.mapCenter) : fromLonLat([-110.926,32.221743]); // default to center of US
    let tempMap = null;
    tempMap = new Map({
      layers: [
        tilesource
      ],
      view: new View({center: center, zoom: 10}),
      target: 'map',
      controls: []
    });
    setMapState(tempMap);
  }

  return (
    <div id='map' style={{width: '100%', height: height, borderStyle: "solid", borderWidth: "thin"}} />   
  )
}

export default MapBase